import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { getTrackByFn } from '@y42/angular/util';
import { IconModule } from '@y42/core/icon';
import { GojsHtmlInfoContextMenuItem } from '../gojs-html-info.model';

@Component({
  selector: 'y42-gojs-sub-context-menu',
  standalone: true,
  imports: [CommonModule, MatMenuModule, MatButtonModule, MatDividerModule, IconModule],
  template: `
    <mat-menu #childMenu="matMenu" [overlapTrigger]="false" class="gojs-sub-context-menu">
      <ng-container *ngFor="let child of items; trackBy: trackByLabel">
        <!-- Handle node with children -->
        <ng-container *ngIf="!!child.children?.length">
          <button
            mat-menu-item
            [matMenuTriggerFor]="menu.childMenu"
            #subMenuTrigger="matMenuTrigger"
            (mouseover)="subMenuTrigger.openMenu()"
          >
            <y42-icon *ngIf="child.icon" [icon]="child.icon"></y42-icon>
            {{ child.label }}
          </button>
          <y42-gojs-sub-context-menu #menu [items]="child.children"></y42-gojs-sub-context-menu>
        </ng-container>

        <!-- Handle leaf node menu items -->
        <span *ngIf="!child.children?.length">
          <button mat-menu-item (click)="child.callback()">
            <y42-icon *ngIf="child.icon" [icon]="child.icon"></y42-icon>
            {{ child.label }}
          </button>
        </span>
      </ng-container>
    </mat-menu>
  `,
  styles: [
    `
      :host {
        ::ng-deep .gojs-sub-context-menu {
          .mat-menu-item {
            line-height: 30px;
            height: 30px;
          }
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GojsSubContextMenuComponent {
  @Input() items?: GojsHtmlInfoContextMenuItem[];

  @ViewChild('childMenu') public childMenu!: MatMenu;

  readonly trackByLabel = getTrackByFn<GojsHtmlInfoContextMenuItem>('label');
}
